// Generated by purs version 0.13.8
"use strict";
var CSS_Font = require("../CSS.Font/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Halogen_HTML_CSS = require("../Halogen.HTML.CSS/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var highlightedClass = "highlighted";
var highlight = function (color) {
    return function (inner) {
        return Halogen_HTML_Elements.span([ Halogen_HTML_CSS.style(CSS_Font.color(color)) ])([ inner ]);
    };
};
var bold = (function () {
    var $0 = Halogen_HTML_Elements.span([ Halogen_HTML_CSS.style(CSS_Font.fontWeight(CSS_Font.bold)) ]);
    var $1 = Control_Applicative.pure(Control_Applicative.applicativeArray);
    return function ($2) {
        return $0($1($2));
    };
})();
module.exports = {
    highlight: highlight,
    bold: bold
};
